"use client"

import { Button } from "@/components/ui/button"
import { ArrowLeft } from "lucide-react"

interface CareerHeaderProps {
  careerName: string
  description: string
  matchPercentage: number
  category: string
  imageUrl: string
  onBack: () => void
}

export function CareerHeader({
  careerName,
  description,
  matchPercentage,
  category,
  imageUrl,
  onBack,
}: CareerHeaderProps) {
  return (
    <div className="space-y-6">
      {/* Back Button */}
      <Button onClick={onBack} className="flex items-center gap-2 bg-gray-200">
        <ArrowLeft className="w-4 h-4" />
        <span>Back</span>
      </Button>

      {/* Career Info Section */}
      <div className="bg-slate-100 p-6 sm:p-8 rounded-2xl shadow-lg flex flex-col md:flex-row items-start md:items-center gap-6">
        {/* Career Image */}
        <img
          alt={`${careerName} illustration`}
          src={imageUrl || "/placeholder.svg"}
          className="w-24 h-24 sm:w-32 sm:h-32 object-cover rounded-full border-4 border-slate-100 flex-shrink-0"
        />

        {/* Career Details */}
        <div className="flex-grow">
          <h1 className="text-4xl sm:text-5xl font-bold text-slate-900">{careerName}</h1>
          <p className="mt-2 text-slate-600 max-w-2xl">{description}</p>
        </div>

        {/* Badges */}
        <div className="flex flex-col items-start md:items-end gap-3 self-start md:self-center mt-4 md:mt-0 flex-shrink-0">
          <div className="flex items-center gap-2 bg-teal-100 text-teal-800 px-4 py-2 rounded-full font-medium text-lg">
            <span className="text-teal-600">👍</span>
            <span>{matchPercentage}% Match</span>
          </div>
          <div className="flex items-center gap-2 bg-indigo-100 text-indigo-800 px-3 py-1 rounded-full font-medium text-sm">
            <span className="text-indigo-600">🎨</span>
            <span>{category}</span>
          </div>
        </div>
      </div>
    </div>
  )
}
